import { AppError } from "../../../shared/utils/error-handler";
import type { AdminMachineRepository } from "../../repositories/admin/admin-machine-repository";
import type { MachineDetailDto, RouterMachinesResponse } from "../../types/machine";

export class AdminMachineUseCase {
  constructor(private adminMachineRepository: AdminMachineRepository) {}

  async getMachines(
    companyId: number,
  ): Promise<MachineDetailDto[]> {
    try {
      return await this.adminMachineRepository.getMachines(companyId);
    } catch (error) {
      throw new AppError(
        String(error) || "기계 정보를 불러오지 못했습니다.",
        "KPI_CERTIFICATION_KEY_UPDATE_FAILED",
        error
      );
    }
  }

  async getMachineDetailsByRouter(
    companyId: number,
  ): Promise<RouterMachinesResponse[]> {
    try {
      return await this.adminMachineRepository.getMachineDetailsByRouter(companyId);
    } catch (error) {
      throw new AppError(
        String(error) || "기계 정보를 불러오지 못했습니다.",
        "KPI_CERTIFICATION_KEY_UPDATE_FAILED",
        error
      );
    }
  }
}
